// extracted by mini-css-extract-plugin
export var container = "styles-module__container___AOHWp";
export var headerAndSubText = "styles-module__headerAndSubText___zcuYO";
export var subHeadAndSubText = "styles-module__subHeadAndSubText___f9uPq";
export var imageA = "styles-module__imageA___Z6Smp";
export var imageC = "styles-module__imageC___d6ezi";
export var largeImage = "styles-module__largeImage___Nn4wv";
export var header = "styles-module__header___gUIDs";
export var perfectForAllContainer = "styles-module__perfectForAllContainer___Me1Sm";
export var andMore = "styles-module__andMore___QjQdQ";
export var subText = "styles-module__subText___TwToU";
export var subHeader = "styles-module__subHeader___QEfJ9";
export var imageGrid = "styles-module__imageGrid___umcNy";
export var leftImageColumn = "styles-module__leftImageColumn___OET3E";
export var subImages = "styles-module__subImages___rquzv";
export var athleteList = "styles-module__athleteList___r5ptP";
export var imageAndBlurbs = "styles-module__imageAndBlurbs___jfVkP";
export var gc = "styles-module__gc___kdfMl";
export var blurbs = "styles-module__blurbs___VMxiU";
export var rightImageColumn = "styles-module__rightImageColumn___jTuB_";